module.exports = __webpack_public_path__ + "img/app_proofreader.0fc243ea.png";